import { TFunction } from '@lyearn/i18n';
// components
import { Star } from '@lyearn/icons';
// types
import { ActionMenuProps } from '@lyearn/molecules';
import { cn } from '@lyearn/style';
import { SELECTED_ITEM_OVERRIDES } from '@/modules/corporate/modules/database/views/TableView/components/cells/Header/utils/getSubMenuItems';
import { DatabaseRatingTypeEnum } from '@/types/schema';

import RatingItemNumber from '../components/RatingItemNumber';

const getRatingOptions = (t: TFunction, type: DatabaseRatingTypeEnum): ActionMenuProps['items'] => [
  {
    id: DatabaseRatingTypeEnum.Star,
    StartIcon: Star,
    label: t('Database:SelectOptions.Icon'),
    ...(type === DatabaseRatingTypeEnum.Star && SELECTED_ITEM_OVERRIDES),
  },
  {
    id: DatabaseRatingTypeEnum.Number,
    startIcon: (
      <RatingItemNumber
        className={cn(
          'text-white me-16',
          type === DatabaseRatingTypeEnum.Number
            ? 'bg-icon-active'
            : 'bg-icon-secondary group-hover:bg-icon-active',
        )}
        size={20}
        value={1}
      />
    ),
    label: t('Database:SelectOptions.Number'),
    ...(type === DatabaseRatingTypeEnum.Number && SELECTED_ITEM_OVERRIDES),
  },
];

export default getRatingOptions;
